/* Gravurephoto – détourage précis (ISNet) en secours de MODNet + bouton Signes plus visible.
   M. Boursault L. avec Claude */
(()=>{
const P=window.GpPhotoElement,L=window.GpPhotoLib;
if(!P||!L||P.prototype._isnet)return;
const p=P.prototype;p._isnet=1;

/* Modèle ISNet « usage général » (Apache 2.0), version allégée 44 Mo, chargée seulement si besoin */
const ISNET_URL="https://huggingface.co/SacredNoir/isnet-general-use-onnx/resolve/main/isnet-general-use-q8.onnx",S=1024;

const TR={
 fr:{adv:"Détourage pas réussi ? Essayer le détourage précis",busy:"Détourage précis en cours… (quelques secondes)",fail:"Le détourage précis n'a pas pu être fait. Vous pouvez garder le fond de la photo : notre atelier s'en chargera."},
 en:{adv:"Cut-out not right? Try the precise cut-out",busy:"Precise cut-out in progress… (a few seconds)",fail:"The precise cut-out could not be done. You can keep the photo background: our workshop will take care of it."},
 de:{adv:"Freistellung nicht gelungen? Präzise Freistellung versuchen",busy:"Präzise Freistellung läuft … (einige Sekunden)",fail:"Die präzise Freistellung war nicht möglich. Sie können den Hintergrund behalten: unsere Werkstatt kümmert sich darum."},
 es:{adv:"¿El recorte no está bien? Probar el recorte preciso",busy:"Recorte preciso en curso… (unos segundos)",fail:"No se pudo hacer el recorte preciso. Puede conservar el fondo de la foto: nuestro taller se encargará."}
};
const T=TR[(document.documentElement.lang||"fr").slice(0,2).toLowerCase()]||TR.fr;

/* Second moteur, même worker que MODNet ; on passe des valeurs pré-échelonnées pour obtenir pixel/255-0.5 */
const E2=Object.assign({},L.Engine,{worker:null,ready:null,jobs:new Map,seq:0});
const isnetMask=async(img,cfg)=>{
 const c=L.canvas(S,S).getContext("2d",{willReadFrequently:!0});
 c.imageSmoothingQuality="high";c.drawImage(img,0,0,S,S);
 const d=c.getImageData(0,0,S,S).data,f=new Float32Array(d.length);
 for(let i=0;i<d.length;i++)f[i]=d[i]/2+63.75;
 const r=await E2.run({ortUrl:cfg.ortUrl,modelUrl:ISNET_URL},f,S,S),m=r.mask;
 let mn=1/0,mx=-1/0;for(let i=0;i<m.length;i++){const v=m[i];v<mn&&(mn=v);v>mx&&(mx=v)}
 const k=mx>mn?1/(mx-mn):1;
 for(let i=0;i<m.length;i++)m[i]=Math.min(1,Math.max(0,((m[i]-mn)*k-.05)/.8));
 return r;
};

/* Contrôle du détourage : sujet presque vide ou coupé en morceaux => mauvais */
const bad=cv=>{
 const s=L.scaledCopy(cv,128),W=s.width,H=s.height,N=W*H,
  d=s.getContext("2d",{willReadFrequently:!0}).getImageData(0,0,W,H).data,f=new Uint8Array(N);
 let n=0;for(let i=0;i<N;i++)d[4*i+3]>127&&(f[i]=1,n++);
 if(n<.03*N)return!0;
 let best=0;const st=[];
 for(let i=0;i<N;i++)if(1===f[i]){let c=0;f[i]=2;st.push(i);
  while(st.length){const j=st.pop(),x=j%W;c++;
   for(const q of[x>0?j-1:-1,x<W-1?j+1:-1,j-W,j+W])q>=0&&q<N&&1===f[q]&&(f[q]=2,st.push(q))}
  c>best&&(best=c)}
 return best<.9*n;
};

/* Bouton « détourage précis » */
p.advUi=function(){
 const row=this.el&&this.el.keepRow;if(!row)return;
 let b=this.el.adv;
 if(!b){b=document.createElement("button");b.type="button";b.className="gp-photo__btn gp-photo__adv";b.textContent=T.adv;
  b.addEventListener("click",()=>this.orig&&this.detourPrecis(this._token,!0));row.after(b);this.el.adv=b}
 b.hidden=!(this.orig&&"portrait"===this.cfg.mode&&this.cutout&&!this.precis&&!this.pending);
};

p.detourPrecis=function(t,manual){
 const job=(async()=>{
  this.setStatus(T.busy,!0);this.advUi();
  try{
   const r=await isnetMask(this.orig,this.cfg);if(t!==this._token)return;
   this.cutout=L.applyMask(this.orig,r.mask,r.w,r.h);this.fond="retire";this.precis=1;
   this.el.keep.checked||(this.rebuildSubject(!1),this.fit());this.draw();
  }catch(e){
   console.warn("[gp-photo] détourage précis indisponible",e);
   if(manual&&t===this._token){this.el.warn.textContent=T.fail;this.el.warn.hidden=!1}
  }finally{t===this._token&&(this.setStatus(""),this.pending===job&&(this.pending=null),this.advUi())}
 })();
 return this.pending=job,job;
};

const od=p.detour;
p.detour=async function(t){
 this.precis=0;
 await od.call(this,t);
 if(t!==this._token)return;
 if(this.cutout&&bad(this.cutout))await this.detourPrecis(t,!1);
 else this.advUi();
};

const pu=p.photoUi;
p.photoUi=function(){pu&&pu.apply(this,arguments);this.advUi()};

/* Montage multi-photos : même secours */
if(p.fpDetour){
 const of=p.fpDetour;
 p.fpDetour=function(t,o){
  const job=(async()=>{
   await of.call(this,t,o);
   if(!(this.fp||[]).includes(t)||!t.cut||!bad(t.cut))return;
   t.pending=job;this.fpUi&&this.fpUi();this.setStatus(T.busy,!0);
   try{
    const r=await isnetMask(t.orig,this.cfg);if(!(this.fp||[]).includes(t))return;
    t.cut=L.applyMask(t.orig,r.mask,r.w,r.h);t.fond="retire";
    if(!t.keep){const pos={x:t.st.x,y:t.st.y};this.fpSubject(t,!0,o);t.st.x=pos.x;t.st.y=pos.y;this.draw()}
   }catch(e){console.warn("[gp-photo] détourage précis du montage indisponible",e)}
   finally{t.pending=null;this.setStatus("");this.fpUi&&this.fpUi()}
  })();
  return job;
 };
}

/* Bouton « Ajouter un signe » plus visible, avec quelques signes en aperçu */
const ICONS='<span class="gp-sg-ico" aria-hidden="true">'+
 '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"/></svg>'+
 '<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M6.5 8.5C4 8.5 2.5 10 2.5 12s1.5 3.5 4 3.5c3.5 0 7.5-7 11-7 2.5 0 4 1.5 4 3.5s-1.5 3.5-4 3.5c-3.5 0-7.5-7-11-7z"/></svg>'+
 '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>'+
 '<svg viewBox="0 0 24 24"><g fill="currentColor"><circle cx="6.5" cy="9.5" r="2.2"/><circle cx="12" cy="6.5" r="2.2"/><circle cx="17.5" cy="9.5" r="2.2"/><path d="M12 11c-3 0-5.5 4-5.5 6 0 1.5 1.2 2.5 2.7 2.2 1-.2 1.8-.7 2.8-.7s1.8.5 2.8.7c1.5.3 2.7-.7 2.7-2.2 0-2-2.5-6-5.5-6z"/></g></svg>'+
 '</span>';
if(!document.getElementById("gp-sg-style")){
 const st=document.createElement("style");st.id="gp-sg-style";
 st.textContent=".gp-photo__sg-pick.gp-sg-big{display:inline-flex;align-items:center;gap:.6em;background:#14161a;color:#fff;border:1px solid #14161a;font-weight:600;padding:.65em 1.1em;border-radius:6px;cursor:pointer}"+
 ".gp-photo__sg-pick.gp-sg-big:hover{background:#2b2f36}.gp-photo__sg-pick.gp-sg-big:disabled{opacity:.5;cursor:default}"+
 ".gp-sg-ico{display:inline-flex;gap:.3em}.gp-sg-ico svg{width:1.15em;height:1.15em;display:block}"+
 ".gp-photo__adv{margin-top:.5em}";
 document.head.appendChild(st);
}
const deco=el=>{
 const ui=el.sg&&el.sg.ui;if(!ui)return;
 Object.values(ui).forEach(u=>{const b=u&&u.pick;if(!b)return;b.classList.add("gp-sg-big");
  if(b.querySelector(".gp-sg-ico"))return;
  const tx=b.textContent.trim();b.innerHTML=(b.disabled?"":ICONS)+"<span>"+tx+"</span>"});
};
if(p.initSigns){const oi=p.initSigns;p.initSigns=function(){oi.apply(this,arguments);deco(this)}}
if(p.syncSignsUi){const os=p.syncSignsUi;p.syncSignsUi=function(){os.apply(this,arguments);deco(this)}}
document.querySelectorAll("gp-photo").forEach(el=>{el.sg&&deco(el);el.cfg&&el.advUi()});
})();
